export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/rec-dowload-drawer-tag.a876ae40.png";